export function saveFiltersPlans (context, data) { 
    context.commit('SAVE_FILTERS_PLANS',data);
}
